import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuthClient = (currentPromo) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (currentPromo && !localStorage.getItem('accessToken')) {
            navigate(`/${currentPromo.path}/signin`);
        }
    }, [navigate, currentPromo]);

};

export default useAuthClient;
